var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomReceptor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 0H14C6.54416 0 0.5 6.04416 0.5 13.5V58.5C0.5 65.9558 6.54416 72 14 72H59C66.4558 72 72.5 65.9558 72.5 58.5V13.5C72.5 6.04416 66.4558 0 59 0Z",
    fill: "#AECBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9703 32.9897C49.6316 26.3555 43.6662 21.375 36.5 21.375C30.8103 21.375 25.8688 24.5287 23.4078 29.1438C17.4819 29.7591 12.875 34.6627 12.875 40.6046C12.875 46.9697 18.1709 52.1424 24.6875 52.1424H50.2812C55.715 52.1424 60.125 47.835 60.125 42.5276C60.125 37.451 56.0891 33.3358 50.9703 32.9897Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2601_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomReceptor);
export default __webpack_public_path__ + "static/media/custom_receptor.b4f18e02.svg";
export { ForwardRef as ReactComponent };